import { Button } from "@mui/material";
import { Box, Typography } from "@mui/material";
import React, { FC } from "react";
import { useIntl } from "react-intl";
import I18nKey from "../../../translations/I18nKey";
import { TrialMessageProps } from "../types";
import Tour from "assets/Icons/Tour.svg";
import { freeTrialHeaderStyles } from "./styles";
import { useMediaQuery } from "@mui/material";
const TrialMessage: FC<TrialMessageProps> = ({
  handleInputFocus,
  value,
  customStyle,
}) => {
  const intl = useIntl();
  const isMobile = useMediaQuery("(max-width: 768px)");
  return (
    <Button onClick={handleInputFocus} sx={customStyle}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {!isMobile && (
          <Typography sx={freeTrialHeaderStyles}>
            {intl.formatMessage({
              id: I18nKey.TRIAL,
            })}
          </Typography>
        )}
        {isMobile ? null : <img src={Tour} alt="menu" height="25px" />}
      </Box>
    </Button>
  );
};

export default TrialMessage;
